import React, { useEffect, useState } from 'react';
import { XIcon } from 'lucide-react';
interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}
export const WelcomeModal = ({
  isOpen,
  onClose
}: WelcomeModalProps) => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    // Initial check
    checkIfMobile();
    // Add event listener for window resize
    window.addEventListener('resize', checkIfMobile);
    // Cleanup
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-75" data-id="element-771">
      <div className={`bg-[#282828] ${isMobile ? 'w-full max-h-[90vh] m-4' : 'max-w-lg w-full mx-4'} rounded-xl relative overflow-hidden`} data-id="element-772">
        <button onClick={onClose} className="absolute right-4 top-4 p-2 hover:bg-white/10 rounded-full transition-colors z-10" data-id="element-773">
          <XIcon className="w-6 h-6" data-id="element-774" />
        </button>
        <div className="p-6 sm:p-8" data-id="element-775">
          <img src="https://images.unsplash.com/photo-1536440136628-849c177e76a1" alt="Movies on Spotify" className="w-full h-48 object-cover rounded-lg mb-6" data-id="element-776" />
          <h2 className="text-2xl font-bold mb-4" data-id="element-777">
            Welcome to Spotify Movies!
          </h2>
          <p className="text-gray-300 mb-6" data-id="element-778">
            We're excited to introduce movies on Spotify! Now you can enjoy your
            favorite films alongside your music and podcasts, all in one place.
            Browse our collection of trending movies, create watchlists, and
            continue watching where you left off.
          </p>
          <div className="flex justify-end" data-id="element-779">
            <button onClick={onClose} className="bg-white text-black px-6 py-3 rounded-full font-semibold hover:bg-opacity-90 transition-colors" data-id="element-780">
              Get Started
            </button>
          </div>
        </div>
      </div>
    </div>;
};